import { apiClient } from "helpers/api_helper";

export const GetGoldRateLogData = async (query: {
  searchValue?: string;
  fromDate?: string;
  toDate?: string;
}) => {
  try {
    const params = new URLSearchParams();

    if (query.searchValue && query.searchValue.trim() !== "") {
      params.append("SearchValue", query.searchValue);
    }
    if (query.fromDate && query.fromDate.trim() !== "") {
      params.append("fromDate", query.fromDate);
    }
    if (query.toDate && query.toDate.trim() !== "") {
      params.append("toDate", query.toDate);
    }

    const url = `/api/v1/Report/GetGoldRateLogReport${
      params.toString() ? `?${params.toString()}` : ""
    }`;

    const response = await apiClient.get(url);
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};
